module.exports = __webpack_public_path__ + "videos/kviz-science-CZ.5523179.mp4";